import React from 'react';


const VettingHomeIcon = (props) => {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5 11.4999H21.5L19.5 9.48487V3.49987H16.5V6.49987L13.1175 2.91862C12.5825 2.34862 11.395 2.37112 10.8825 2.91862L2.5 11.4999H4.5V20.4999C4.5 21.0522 4.94772 21.4999 5.5 21.4999H10.5V15.4999H13.5V21.4999H18.265C18.8175 21.4999 19.5 20.9274 19.5 20.3749V11.4999"  stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.3242 21.5H13.6767"  stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default VettingHomeIcon;